module.exports = __webpack_public_path__ + "static/screenshot4-d9d7f1242011d0bb9f6153ae201b7ee0.png";